module.exports = __webpack_public_path__ + "img/hall-li3.352d6757.png";